module.exports = __webpack_public_path__ + "static/media/scratch_1.c93a85fb.png";